import request from '@/utils/request'
import requestMini from '@/utils/request-mini'
import host from '@/api/base/host'

// 订单模块
const order = host.path('dev', { module: 'order', dev: 'v1/order' }) // 开发地址:ljs
const order2 = host.path('dev', { module: 'order', dev: 'v1/mini/order' }) // 开发地址:ljs
const orderv2 = host.path('dev', { module: 'order', dev: 'v2/order/h5' }) // 开发地址:ljs
export default {
  // 1.1 获取下单购买信息
  preCreate(data) {
    return request({ url: order('preCreate'), method: 'post', data })
  },
  preCreateByLimit(data) {
    return request({ url: order('preCreateByLimit'), method: 'post', data })
  },
  preCreateMini(data) {
    return requestMini({ url: order2('preCreate'), method: 'post', data })
  },
  // 获取抵扣列表
  getDisCountOrderList(data) {
    return request({ url: order('getDisCountOrderList'), method: 'post', data })
  },
  // 1.2 创建订单
  create(data) {
    return request({ url: orderv2('create'), method: 'post', data })
  },
  // 创建积分商品订单
  createIntegral(data) {
    return request({ url: orderv2('credit'), method: 'post', data })
  },
  createMini(data) {
    return requestMini({ url: order2('create'), method: 'post', data })
  },
  createByLimit(data) {
    return request({ url: orderv2('createByLimit'), method: 'post', data })
  },
  // 1.3 获取支付状态
  getPayStatus(data) {
    // goodsId、prePayId
    return request({
      url: order(data.orderSn ? 'getCreateOrderStatusByPrePayId' : 'getPayStatusByPrePayId'),
      method: 'post',
      data
    })
  },

  // 1.3 取消了订单支付的
  cancelOrder(data) {
    return request({ url: order('cancelOrder'), method: 'post', data })
  },

  // 获取用户的已经购买的商品列表
  // getGoodsByUserId,

  // 根据订单获取商品信息
  getGoodsByOrderSn(data) {
    return request({ url: order('getGoodsByOrderSn'), method: 'post', data })
  },

  // 根据订单获取支付计划信息
  // getPlanByOrderSn

  // 分期订单支付
  // payment
  // 获取管理后台订单支付信息
  getOrderDetail(data) {
    return request({ url: order('pay/detail'), method: 'post', data })
  },
  // 用户支付管理后台订单
  payOrder(data) {
    return request({ url: orderv2('pay/payment'), method: 'post', data })
  }
}
